import { render, staticRenderFns } from "./ViewReseller.vue?vue&type=template&id=f0d0cf88&scoped=true"
import script from "./ViewReseller.vue?vue&type=script&lang=js"
export * from "./ViewReseller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d0cf88",
  null
  
)

export default component.exports